module.exports = __webpack_public_path__ + "assets/img/pyone.1c91b394.png";